module.exports = __webpack_public_path__ + "img/tema-1-9.7de91d39.svg";